import { ListObligation } from "models/list-obligation";
import { doGet } from "../request";

export const userDoGetListObligation = async (listUuid: string) => {
  const obligation = await doGet<ListObligation>(
    `/user/list/${listUuid}/obligation`,
  );
  return obligation;
};
